module.exports = __webpack_public_path__ + "media/images/common/sns/apple-db2b544f22064e57fbb99fdfd45e1ba7.svg";